__turbopack_context__.v({
  "loginFirm__help": "LoginForm-module__SHmV9q__loginFirm__help",
  "loginFirm__logo": "LoginForm-module__SHmV9q__loginFirm__logo",
  "loginFormContainer": "LoginForm-module__SHmV9q__loginFormContainer",
});
